import React, { ComponentPropsWithoutRef } from "react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomLink } from "../CustomLink";
import { CustomSVG } from "../_primitives/CustomSVG/CustomSVG";

interface TranscriptButtonProps extends Omit<
  ComponentPropsWithoutRef<"a">,
  "href" | "aria-label"
> {
  href: string;
  ariaLabel: string;
}

export const TranscriptButton = React.forwardRef<
  HTMLAnchorElement,
  TranscriptButtonProps
>(({ href, ariaLabel, className = "", ...props }, ref) => {
  const { getIcon } = useGlobalContext();

  return (
    <CustomLink
      ref={ref}
      className={className}
      href={href}
      target="_blank"
      aria-label={ariaLabel}
      {...props}
    >
      <CustomSVG
        width={32}
        height={32}
        src={getIcon("video-controls-transcript")}
        wrapper="span"
        aria-hidden="true"
        className="vds-icon is-flex"
      />
    </CustomLink>
  );
});

TranscriptButton.displayName = "TranscriptButton";
